import { z } from 'zod';
// Relationships owns this projection; Knowledge remains an optional runtime provider.
export const relationshipsContactNoteSnippetsCapability = 'knowledge.snippets.v1';
export const relationshipsContactNoteSnippetsProviderId = 'knowledge.server.contact-snippets';
export const relationshipsContactNoteSnippetsSlot = 'relationships.contact-note-snippets';
export const relationshipsContactNoteSnippetCategorySchema = z.enum([
    'general', 'note', 'email', 'invoice', 'estimate', 'status_update',
]);
export const relationshipsContactNoteSnippetQuerySchema = z.strictObject({
    search: z.string().trim().max(160).default(''),
    category: relationshipsContactNoteSnippetCategorySchema.optional(),
    limit: z.number().int().min(1).max(250).default(100),
    offset: z.number().int().nonnegative().default(0),
});
export const relationshipsContactNoteSnippetSchema = z.strictObject({
    id: z.string().uuid(),
    tenantId: z.string().uuid(),
    createdByUserId: z.string().uuid(),
    title: z.string().min(1).max(200),
    body: z.string().min(1),
    category: relationshipsContactNoteSnippetCategorySchema,
    isShared: z.boolean(),
    revision: z.number().int().positive(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
});
export const relationshipsContactNoteSnippetPageSchema = z.strictObject({
    data: z.array(relationshipsContactNoteSnippetSchema),
    page: z.strictObject({
        limit: z.number().int().min(1).max(250),
        offset: z.number().int().nonnegative(),
        returned: z.number().int().nonnegative(),
        total: z.number().int().nonnegative(),
    }),
}).superRefine((response, context) => {
    const count = response.data.length;
    if (response.page.returned !== count || count > response.page.limit ||
        count > Math.max(0, response.page.total - response.page.offset) ||
        new Set(response.data.map(({ id }) => id)).size !== count) {
        context.addIssue({ code: 'custom', path: ['page'], message: 'Snippet page does not match its rows.' });
    }
});
export const relationshipsContactNoteSnippetsProviderResponseSchema = z.strictObject({
    contractVersion: z.literal(relationshipsContactNoteSnippetsCapability),
    providerId: z.literal(relationshipsContactNoteSnippetsProviderId),
    tenantId: z.string().uuid(),
    requestId: z.string().uuid(),
    result: relationshipsContactNoteSnippetPageSchema,
});
export const relationshipsContactNoteSnippetsResultSchema = z.discriminatedUnion('state', [
    z.strictObject({ state: z.literal('present'), data: relationshipsContactNoteSnippetPageSchema }),
    z.strictObject({
        state: z.literal('unavailable'),
        reasonCode: z.enum(['not-installed', 'not-enabled', 'permission-denied', 'provider-invalid', 'provider-failed']),
    }),
]);
//# sourceMappingURL=relationships-contact-note-snippets.contract.js.map